import { Component, OnInit } from '@angular/core';
import { AppMetaDataItemNames } from '../../../../meta-data/app-meta-data.service';
import { AppPermissions } from '../../../../meta-data/app-permissions.enum';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { DwComponent, DwComponentType, DwRoutingService, DwSecurityUserService } from '@devwareapps/devware-cap';
import { Subscription } from 'rxjs';



@DwComponent({
  key: 'school-profile',
  name: ' School Profile',
  componentType: DwComponentType.pageComponent,
  //parentItemName: AppMetaDataItemNames.FlightSchoolOrganization,
  isGlobal: true
})
@Component({
  selector: 'app-school-profile',
  template: `
  <div *ngIf="keyValue">
    <dw-default-form #mdForm [item]="flightSchoolOrganization" [configKeyPart]="configKeyPart" [keyValue]="keyValue">
    </dw-default-form>
  </div>
  `
})
export class SchoolProfileComponent implements OnInit {
  flightSchoolOrganization = AppMetaDataItemNames.FlightSchoolOrganization;

  configKeyPart = 'schoolProfile';

  keyValue: number;
  subscriptions: Subscription[] = [];

  constructor(
    private adminManagerService: AdminManagerService,
    private securityUserService: DwSecurityUserService,
    private dwRoutingService: DwRoutingService
  ) {

  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.securityUserService.securityContextChanged().subscribe(securityContext => {

        this.setupFlightSchoolOrganization();
        
      })
    );

    this.setupFlightSchoolOrganization();
  }

  setupFlightSchoolOrganization(): void {
    const user = this.adminManagerService.getPilexosUser();

    this.keyValue = user.flightSchoolOrganizationId;

    // If the user does not have a school organization or permission to manage its settings, navigate home.
    if (!this.keyValue || !user.hasPermission(AppPermissions.flightSchoolCanManageSchoolSettings)) {
      this.dwRoutingService.navigateToUrl('/');
    }
  }
}
